import React from 'react';
import { PBI_PAGE } from '../../../../content/enterpriseMessaging';

/** Compact narrative band below the Interactive Analytics hero. */
export default function TalkToDataIntro() {
  const copy = PBI_PAGE.hero.manifesto;
  const bodyClass = 'mt-3 text-pretty text-base leading-relaxed text-ink-600 sm:text-lg';

  return (
    <div className="mx-auto max-w-3xl border-t border-ink-200/60 px-6 pt-6 text-center sm:px-10 sm:pt-8">
      <p className="eyebrow">{copy.eyebrow}</p>
      <p className={bodyClass}>{copy.body}</p>
      {copy.close ? <p className={bodyClass}>{copy.close}</p> : null}
    </div>
  );
}
